import Image from "@/components/elements/Image";
import * as styles from "./styles.module.scss";

export function FooterHeader({
  logo,
  description,
}: Pick<FooterTemplate, "logo" | "description">) {
  return (
    <div className={styles.footerHeader}>
      <div className={styles.footerHeaderContainer}>
        {logo && (
          <div className={styles.footerLogo}>
            <Image
              data={logo?.filename as StoryblokGatsbyImageAsset}
              alt={logo?.alt}
              options={{ width: 138.5, height: 64 }}
              fixed
            />
          </div>
        )}
        {description && <p className={styles.description}>{description}</p>}
      </div>
    </div>
  );
}
